import React from 'react';
import styled from 'styled-components';
import { useAnalytics } from '../../utils/analytics-provider/analytics-provider';
import { Hero } from './hero';
import { QuickAnswers } from './quick-answers';
import { BrowseTopics } from './browse-topics';
import { PopularArticles } from './popular-articles';
import { ContactFlow } from './contact-flow';
import { HomeProvider } from './context';

const Wrapper = styled.div`
  margin: 0 auto;
  min-height: 100vh;
`;

const HomePage = () => {
  const { trackEvent } = useAnalytics();
  trackEvent('page_hit', { page_hit: 'home' });

  return (
    <HomeProvider>
      <Wrapper>
        <Hero />

        <QuickAnswers />

        <BrowseTopics />

        <PopularArticles />

        <ContactFlow />
      </Wrapper>
    </HomeProvider>
  );
};

export default HomePage;
